const certificatesData = [
  {
    id: "generative-ai-google",
    title: "Generative AI Certification",
    organization: "Google Cloud",
    issueDate: "2025-06-21",
    certificateId: "017fc088f90c9ea44ba5ffa09304c8f3",
    certificateUrl: "https://coursera.org/share/017fc088f90c9ea44ba5ffa09304c8f3",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Generative%20AI.png?alt=media",
    priority: 1,
  },
  {
    id: "ibm-cloud-internship",
    title: "PBEL Equivalent to Virtual Internship - Cloud Computing",
    organization: "IBM / IBMMooc",
    issueDate: "2025-07-21",
    certificateId: "53eb549450584a8c9ba43ff3dc3eedbc",
    certificateUrl: "https://courses.ibmmooc.skillsnetwork.site/certificates/53eb549450584a8c9ba43ff3dc3eedbc",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-07-25%20011859.png?alt=media",
    priority: 2,
  },
  {
    id: "intro-cybersecurity",
    title: "Introduction to Cybersecurity",
    organization: "Cisco Networking Academy / NASSCOM",
    issueDate: "2025-06-26",
    certificateId: "1iDdiM12k9sQ4JXfg9N_mdNMOB7FCTG-S",
    certificateUrl: "https://drive.google.com/file/d/1iDdiM12k9sQ4JXfg9N_mdNMOB7FCTG-S/view",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-07-25%20013015.png?alt=media",
    priority: 3,
  },
  {
    id: "aws-cloud-masterclass",
    title: "AWS Cloud Masterclass - Cloud Practitioner Essentials",
    organization: "Amazon Web Services",
    issueDate: "2025-05-25",
    certificateId: "GCP-123456789",
    certificateUrl: "https://fsprimecertificate.s3-ap-southeast-1.amazonaws.com/AyushRai-ayushrai803@gmail.com-2151995.pdf",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-09-01%20110702.png?alt=media",
    priority: 3,
  },
  {
    id: "java-dsa-scaler",
    title: "Certification of Excellence in the Java DSA Course",
    organization: "Scaler",
    issueDate: "2025-02-23",
    certificateId: "trFSBnNAXf",
    certificateUrl: "https://moonshot.scaler.com/s/sl/trFSBnNAXf",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%20(17).png?alt=media",
    priority: 4,
  },
  {
    id: "responsive-web-design",
    title: "Responsive Web Design",
    organization: "freeCodeCamp",
    issueDate: "2025-02-22",
    certificateId: "fccbe0f5676-d258-424c-8da0-317124490b67-rwd",
    certificateUrl: "https://freecodecamp.org/certification/fccbe0f5676-d258-424c-8da0-317124490b67/responsive-web-design",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%20(11).png?alt=media",
    priority: 5,
  },
  {
    id: "system-design-scaler",
    title: "Certification of Excellence in the Quora System Design Course",
    organization: "Scaler",
    issueDate: "2025-02-24",
    certificateId: "PL4Op0HSvp",
    certificateUrl: "https://moonshot.scaler.com/s/sl/PL4Op0HSvp",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%20(40).png?alt=media",
    priority: 5,
  },
  {
    id: "android-development",
    title: "Certification of Completion for Android App Development",
    organization: "Technophilia",
    issueDate: "2024-10-10",
    certificateId: "TP-ST-1867",
    certificateUrl: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Technophilia.jpeg?alt=media",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Technophilia.jpeg?alt=media",
    priority: 7,
  },
  {
    id: "prod-eg-hackathon",
    title: "Certification of Participation in Prod E-G Hackathon",
    organization: "Unstop",
    issueDate: "2025-02-22",
    certificateId: "63a69032-ead8-44b7-ab01-3b8da47d651d",
    certificateUrl: "https://unstop.com/certificate-preview/63a69032-ead8-44b7-ab01-3b8da47d651d",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%20(12).png?alt=media",
    priority: 8,
  },
  {
    id: "tata-crucible",
    title: "TATA Crucible Campus Quiz 2024",
    organization: "Unstop",
    issueDate: "2024-09-22",
    certificateId: "29295b75-0535-4702-8a86-9dd08f37ae37",
    certificateUrl: "https://unstop.com/certificate-preview/29295b75-0535-4702-8a86-9dd08f37ae37",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%20(13).png?alt=media",
    priority: 9,
  },
  {
    id: "flipkart-grid",
    title: "Flipkart GRiD 6.0 - Software Development Track",
    organization: "Unstop",
    issueDate: "2024-08-19",
    certificateId: "39710998-a3e2-4972-aa3a-dd4ae824a6cf",
    certificateUrl: "https://unstop.com/certificate-preview/39710998-a3e2-4972-aa3a-dd4ae824a6cf",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%20(14).png?alt=media",
    priority: 10,
  },
  {
    id: "adobe-hackathon",
    title: "Adobe India Hackathon",
    organization: "Adobe",
    issueDate: "2025-05-29",
    certificateId: "GCP-12346789",
    certificateUrl: "https://unstop.com/certificate-preview/94088fa4-1070-4091-946b-7ebeb90c55d2",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%202025-09-01%20111550.png?alt=media",
    priority: 10,
  },
  {
    id: "git-github-lewagon",
    title: "Certification of Completion for Intro to Git and Github",
    organization: "Le Wagon",
    issueDate: "2025-02-24",
    certificateId: "7c8wri8in8",
    certificateUrl: "https://app.lewagon.school/certificates/7c8wri8in8",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot%20(41).png?alt=media",
    priority: 12,
  },
  {
    id: "ai-ncat",
    title: "AI NCAT Participation (May 2025)",
    organization: "Naukri Campus",
    issueDate: "2025-05-01",
    certificateId: "683a06ef6c1aa41e163b5ee4",
    certificateUrl: "https://www.naukri.com/campus/certificates/naukri_campus_ai_ncat_participation_may_2025/v0/683a06ef6c1aa41e163b5ee4",
    certificateImage: "https://firebasestorage.googleapis.com/v0/b/portfolio-e6813.appspot.com/o/Screenshot_20250726-230357~2.png?alt=media",
    priority: 13,
  },
];

export default certificatesData;